import {combineReducers} from 'redux';
import UserReducer from './user_reducer'
import RegisterReducer from './register_reducer'
const rootReducer =combineReducers({
user:UserReducer,
register:RegisterReducer
})
export default rootReducer;
